import React, { useRef, useState, useEffect } from 'react';
import { Row, Col, Form, InputGroup, Button } from 'react-bootstrap';
import { FaSearch, FaPlus, FaList } from 'react-icons/fa';
import Tooltip from '@mui/material/Tooltip';

const SearchBarUser = ({
    listOptions,
    handleChangeSearchTerm,
    handleSelectChange,
    handleSearchClick,
    openModal = null,
    fetchInitialData,
    handleChangeEnableDisable,
    selectedOptionAtivo

}) => {

    // Cria uma ref para o campo pesquisarId
    const inputRef = useRef();

    // Função para lidar com a mudança no select
    const handleSelect = (event) => {
        // Chama a função original, se existir
        if (handleSelectChange) {
            handleSelectChange(event);
        }

        // Aplica o foco no campo pesquisarId
        inputRef.current.focus();
    };

    const [selectedOption, setSelectedOption] = useState("1"); 

    const handleSelectChangeEnableDisable = (event) => {
        setSelectedOption(event.target.value); 
        handleChangeEnableDisable(event); 
    };

    useEffect(() => {
        const newSelectedOption = selectedOptionAtivo === true ? "1" : selectedOptionAtivo === false ? "2" : "3";
        setSelectedOption(newSelectedOption);
    }, [selectedOptionAtivo]);


    return (
        <>
            <Row>
                <Col md={2}>
                    <Form.Label htmlFor="ativo" style={{ fontWeight: 'bold' }}>
                        Somente:
                    </Form.Label>
                    <Form.Control
                        id="ativo"
                        as="select"
                        className="mb-2 custom-select"
                        size="sm"
                        value={selectedOption} // Define o valor com base no estado
                        onChange={handleSelectChangeEnableDisable} // Altera para handleSelectChange                 
                    >
                        <option key="1" value="1">Ativados</option>
                        <option key="2" value="2">Desativados</option>
                        <option key="3" value="3">Todos</option>
                    </Form.Control>
                </Col>
                <Col md={3}>
                    <Form.Label htmlFor="listId" style={{ fontWeight: 'bold' }}>
                        Pesquisar por:
                    </Form.Label>
                    <Form.Control
                        id="listId"
                        as="select"
                        className="mb-2 custom-select"
                        size="sm"
                        onChange={handleSelect}
                    >
                        {listOptions.map((option, index) => (
                            <option key={index} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </Form.Control>
                </Col>
                <Col md={7}>
                    <Form.Label htmlFor="pesquisarId" style={{ fontWeight: 'bold' }}>
                        Pesquisar:
                    </Form.Label>
                    <InputGroup size="sm" className="mb-2">
                        <Form.Control
                            ref={inputRef}
                            id="pesquisarId"
                            type="text"
                            aria-label="Small"
                            aria-describedby="inputGroup-sizing-sm"
                            placeholder="Digite para fazer uma pesquisa"
                            onChange={handleChangeSearchTerm}
                        />
                        <Tooltip title="Pesquisar" arrow>
                            <Button
                                variant="outline-secondary"
                                onClick={handleSearchClick}
                            >
                                <FaSearch />
                            </Button>
                        </Tooltip>

                        {openModal != null
                            ? (
                                <Tooltip title="Adicionar" arrow>
                                    <Button variant="outline-secondary" onClick={openModal}>
                                        <span style={{ backgroundColor: 'lightgreen' }}>
                                            <FaPlus color="green" />
                                        </span>
                                    </Button>
                                </Tooltip>
                            ) : null}

                        <Tooltip title="Listar" arrow>
                            <Button variant="outline-secondary" onClick={fetchInitialData}>
                                <span style={{ backgroundColor: 'lightblue', borderRadius: '20%' }}>
                                    <FaList color="blue" />
                                </span>
                            </Button>
                        </Tooltip>
                    </InputGroup>
                </Col>
            </Row>
        </>
    );

};

export default SearchBarUser;
